import dynamic from "next/dynamic";

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false });

type VideoPlayerProps = {
  url: string;
  className?: string;
};

const VideoPlayer = ({
  url,
  className = "relative aspect-ratio-16/9",
}: VideoPlayerProps) => {
  return (
    <div className={className}>
      <ReactPlayer
        className="absolute left-0 top-0"
        url={url}
        data-testid="video-player"
        width="100%"
        height="100%"
        controls={true}
        playsinline={true}
      />
    </div>
  );
};

export default VideoPlayer;
